<template>
  <v-toolbar :dense="true" app>
    <NewGameDialog/>
    <v-spacer></v-spacer>
    <v-btn flat @click="undoScore()">
      <span class="mr-2">Undo</span>
      <v-icon>replay</v-icon>
    </v-btn>
  </v-toolbar>
</template>
<script>

import NewGameDialog from '@/components/NewGameDialog'
import { mapActions } from 'vuex'

export default {
  data: () => ({
  }),
  methods: {
    ...mapActions([
      'addPlayer',
      'undo'
    ]),
    undoScore () {
      this.undo()
    }
  },
  components: {
    NewGameDialog
  }
}
</script>
